module.exports = __webpack_public_path__ + "f1e4458e6298966054f341fdc7bb8000.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/samsung_gear_connect/2.png
// module id = 1836
// module chunks = 1